import { tableActionsCreator } from "app/actions/tableActions";
import { setMultiSelectorPanelThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import { useDispatch } from "react-redux";

const useClearSelectionAndClosePanel = (tableSelectionKey: string, tableSelectionProperty: string): VoidFunction => {
    const dispatch = useDispatch();

    const { clearAllSelectedRows } = tableActionsCreator(tableSelectionKey, tableSelectionProperty);

    return () => {
        dispatch(setMultiSelectorPanelThunk(null));
        dispatch(clearAllSelectedRows());
    };
};

export default useClearSelectionAndClosePanel;
